const reportsActionTypes = {
  // Preorder Revenue Actions
  FETCH_PREORDER_REVENUE: "FETCH_PREORDER_REVENUE",
  FETCH_PREORDER_REVENUE_SUCCESS: "FETCH_PREORDER_REVENUE_SUCCESS",
  FETCH_PREORDER_REVENUE_FAILURE: "FETCH_PREORDER_REVENUE_FAILURE",

  // Top Preorder Products Actions
  FETCH_TOP_PREORDER_PRODUCTS: "FETCH_TOP_PREORDER_PRODUCTS",
  FETCH_TOP_PREORDER_PRODUCTS_SUCCESS: "FETCH_TOP_PREORDER_PRODUCTS_SUCCESS",
  FETCH_TOP_PREORDER_PRODUCTS_FAILURE: "FETCH_TOP_PREORDER_PRODUCTS_FAILURE",

  // Back In Stock Trends Actions
  FETCH_BACK_IN_STOCK_TRENDS: "FETCH_BACK_IN_STOCK_TRENDS",
  FETCH_BACK_IN_STOCK_TRENDS_SUCCESS: "FETCH_BACK_IN_STOCK_TRENDS_SUCCESS",
  FETCH_BACK_IN_STOCK_TRENDS_FAILURE: "FETCH_BACK_IN_STOCK_TRENDS_FAILURE",

  // Top Back In Stock Products Actions
  FETCH_TOP_BACK_IN_STOCK_PRODUCTS: "FETCH_TOP_BACK_IN_STOCK_PRODUCTS",
  FETCH_TOP_BACK_IN_STOCK_PRODUCTS_SUCCESS: "FETCH_TOP_BACK_IN_STOCK_PRODUCTS_SUCCESS",
  FETCH_TOP_BACK_IN_STOCK_PRODUCTS_FAILURE: "FETCH_TOP_BACK_IN_STOCK_PRODUCTS_FAILURE",

  // Back In Stock Conversions Actions
  FETCH_BACK_IN_STOCK_CONVERSIONS: "FETCH_BACK_IN_STOCK_CONVERSIONS",
  FETCH_BACK_IN_STOCK_CONVERSIONS_SUCCESS: "FETCH_BACK_IN_STOCK_CONVERSIONS_SUCCESS",
  FETCH_BACK_IN_STOCK_CONVERSIONS_FAILURE: "FETCH_BACK_IN_STOCK_CONVERSIONS_FAILURE",

  // Date Range Actions
  UPDATE_REPORTS_DATE_RANGE: "UPDATE_REPORTS_DATE_RANGE",

  // Back In Stock Notifications
  FETCH_BACK_IN_STOCK_NOTIFICATIONS: "FETCH_BACK_IN_STOCK_NOTIFICATIONS",
  FETCH_BACK_IN_STOCK_NOTIFICATIONS_SUCCESS: "FETCH_BACK_IN_STOCK_NOTIFICATIONS_SUCCESS",
  FETCH_BACK_IN_STOCK_NOTIFICATIONS_FAILURE: "FETCH_BACK_IN_STOCK_NOTIFICATIONS_FAILURE",

  DELETE_BACK_IN_STOCK_NOTIFICATION: "DELETE_BACK_IN_STOCK_NOTIFICATION",
  DELETE_BACK_IN_STOCK_NOTIFICATION_SUCCESS: "DELETE_BACK_IN_STOCK_NOTIFICATION_SUCCESS",
  DELETE_BACK_IN_STOCK_NOTIFICATION_FAILURE: "DELETE_BACK_IN_STOCK_NOTIFICATION_FAILURE",

  SET_BACK_IN_STOCK_SELECTIONS: "SET_BACK_IN_STOCK_SELECTIONS",
  CLEAR_BACK_IN_STOCK_SELECTIONS: "CLEAR_BACK_IN_STOCK_SELECTIONS",

  // Orders
  FETCH_ORDERS: "FETCH_ORDERS",
  FETCH_ORDERS_SUCCESS: "FETCH_ORDERS_SUCCESS",
  FETCH_ORDERS_FAILURE: "FETCH_ORDERS_FAILURE",

  SET_ORDERS_SELECTIONS: "SET_ORDERS_SELECTIONS",
  CLEAR_ORDERS_SELECTIONS: "CLEAR_ORDERS_SELECTIONS",

  // Send Shipping Delay Emails
  SEND_SHIPPING_DELAY_EMAILS: "SEND_SHIPPING_DELAY_EMAILS",
  SEND_SHIPPING_DELAY_EMAILS_SUCCESS: "SEND_SHIPPING_DELAY_EMAILS_SUCCESS",
  SEND_SHIPPING_DELAY_EMAILS_FAILURE: "SEND_SHIPPING_DELAY_EMAILS_FAILURE",

  // Preorder Notifications Trends Actions
  FETCH_PREORDER_NOTIFICATIONS_TRENDS: "FETCH_PREORDER_NOTIFICATIONS_TRENDS",
  FETCH_PREORDER_NOTIFICATIONS_TRENDS_SUCCESS: "FETCH_PREORDER_NOTIFICATIONS_TRENDS_SUCCESS",
  FETCH_PREORDER_NOTIFICATIONS_TRENDS_FAILURE: "FETCH_PREORDER_NOTIFICATIONS_TRENDS_FAILURE",

  // Email Logs Actions
  FETCH_EMAIL_LOGS: "FETCH_EMAIL_LOGS",
  FETCH_EMAIL_LOGS_SUCCESS: "FETCH_EMAIL_LOGS_SUCCESS",
  FETCH_EMAIL_LOGS_FAILURE: "FETCH_EMAIL_LOGS_FAILURE",
};

export default reportsActionTypes;
